import { styled } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const ModalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
`

export const ModalBackdrop = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.color.black};
  opacity: 0.7;
`

export const ModalDialog = styled.div`
  position: relative;
  background-color: ${props => props.theme.color.white};
  padding: 48px;
  width: 100%;
`

export const ModalTitle = styled.h2`
  font-family: ${props => props.theme.font.secondary};
  color: ${props => props.theme.color.black};
  font-size: 36px;
  margin-bottom: 40px;
  padding-right: 100px;
`

export const ModalBody = styled.div``

export const ModalClose = styled.button`
  ${Reset('button')}
  position: absolute;
  top: 32px;
  right: 32px;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
  z-index: 10;
`
